import { useApplyColorModeContrast } from "./useColorModeContrast";
import { useApplyColorVisionDeficiency } from "./useColorVisionDeficiency";
import { useApplyLegibilityFont } from "./useLegibilityFont";

/**
 * Parent hook for all display mode preferences.
 * Called by DBBL's LibraryProvider (see `providers/displayModesEffects.tsx`).
 * Resolves and applies all accessibility display modes to the DOM.
 */
export const useDisplayModes = () => {
  const colorModeContrast = useApplyColorModeContrast();
  const colorVisionDeficiency = useApplyColorVisionDeficiency();
  const legibilityFont = useApplyLegibilityFont();

  return {
    colorModeContrast,
    colorVisionDeficiency,
    legibilityFont,
    // future: colorScheme
  };
};
